module.exports = __webpack_public_path__ + "static/delightworks-c4188baf68051526086ca5e985045131.jpg";